<!-- Footer -->
<footer class="page-footer font-small special-color-dark pt-4">

    <!-- Copyright -->
    <div class="footer-copyright text-center py-3">© 2020 Copyright: TetrisNumerico
    </div>
    <!-- Copyright -->
  
  </footer>
  <!-- Footer -->